import React, { useMemo } from "react";
import {useAppSelector} from "../../hooks";
import {CartOrder} from "../../interfaces/CartProduct";
import {useTranslation} from "react-i18next";
import {calculateTotalPrice} from "../../utils/calculateTotalPrice";

const ProductCountIncome:React.FC<{id: number, rrp: number}> = ({ id, rrp}) => {

    const cart = useAppSelector<CartOrder[]>(state => state.cart.value)
    const activeOrder = useAppSelector<number>(state => state.activeOrder.value)
    const currUser = useAppSelector((state) => state.user.value);
    const { t } = useTranslation();

    const { incomeTotalPrice } = useMemo(() => {
        if (!cart.length || !cart[activeOrder]) {
            return { incomeTotalPrice: 0 };
        }

        const item = cart[activeOrder].orderItems.find(
            item => item.product.id === id
        );

        if (!item) {
            return { incomeTotalPrice: 0 };
        }

        const { quantityPerBox, pricePerBox, price } = item.product;
        const count = item.count;

        const totalPrice = calculateTotalPrice({
            count,
            price,
            quantityPerBox,
            pricePerBox,
        });

        const incomeTotalPrice = (rrp * count) - totalPrice;

        return { incomeTotalPrice };
    }, [cart, activeOrder, id, rrp]);

    return (
        <span>{Number(incomeTotalPrice).toFixed(2)} {t(currUser.currency)}</span>
    )
}
export default ProductCountIncome;